import {UuidResponseBody} from '@dms/api/shared';

export type Language = 'cs' | 'en' | 'de' | 'es' | 'fr' | 'nl' | 'it' | 'pl' | 'sk';
export type DescriptionGeneratorConfigResponseBody = {
  enabled: boolean;
  language: Language;
  includeModel: boolean;
  includeEngine: boolean;
  includeFeatures: boolean;
  includeCondition: boolean;
  includeBranch: boolean;
  length: number;
  mentionText: string | null;
  additionalInstruction: string | null;
};

export type DescriptionGeneratorConfigRequestBody = {
  enabled: boolean;
  language?: Language | null;
  includeModel: boolean;
  includeEngine: boolean;
  includeFeatures: boolean;
  includeCondition: boolean;
  includeBranch: boolean;
  length: number;
  mentionText: string | null;
  additionalInstruction: string | null;
};

export type UpdateDescriptionGeneratorConfigApiResponse = /** status 204  */ void;
export type UpdateDescriptionGeneratorConfigApiArg = {
  body: DescriptionGeneratorConfigRequestBody;
};

export type GetDescriptionGeneratorConfigApiResponse =
  /** status 200  */ DescriptionGeneratorConfigResponseBody;
export type GetDescriptionGeneratorConfigApiArg = {};

export type PlatformDescriptionGeneratorConfigOverrides = {
  enabled: boolean | null;
  language: Language | null;
  includeModel: boolean | null;
  includeEngine: boolean | null;
  includeFeatures: boolean | null;
  includeCondition: boolean | null;
  includeBranch: boolean | null;
  length: number | null;
  mentionText: string | null;
  additionalInstruction: string | null;
};

/**
 * BE returns the per-platform overrides struct (nullable per field) alongside
 * the current global config. FE merges them client-side to produce the
 * "resolved" view (override wins when non-null, else global).
 */
export type PlatformDescriptionGeneratorConfigResponseBody = {
  overrides: PlatformDescriptionGeneratorConfigOverrides;
  global: DescriptionGeneratorConfigResponseBody;
};

export type PlatformDescriptionGeneratorConfigRequestBody =
  PlatformDescriptionGeneratorConfigOverrides;

export type GetPlatformDescriptionGeneratorConfigApiArg = {
  platformCode: string;
};
export type GetPlatformDescriptionGeneratorConfigApiResponse =
  /** status 200 */ PlatformDescriptionGeneratorConfigResponseBody;

export type UpdatePlatformDescriptionGeneratorConfigApiArg = {
  platformCode: string;
  body: PlatformDescriptionGeneratorConfigRequestBody;
};
export type UpdatePlatformDescriptionGeneratorConfigApiResponse = /** status 204 */ void;

export type ResetPlatformDescriptionGeneratorConfigApiArg = {
  platformCode: string;
};
export type ResetPlatformDescriptionGeneratorConfigApiResponse = /** status 204 */ void;

export type QuickPresetResponseBody = {
  id: string;
  name: string;
  prompt: string;
  isSystem: boolean;
};

export type CreateQuickPresetRequestBody = {
  name: string;
  prompt: string;
};

export type EditQuickPresetRequestBody = {
  name: string;
  prompt: string;
};

export type GetQuickPresetsApiResponse = /** status 200 */ QuickPresetResponseBody[];

export type GetQuickPresetApiResponse = /** status 200 */ QuickPresetResponseBody;
export type GetQuickPresetApiArg = {
  id: string;
};

export type CreateQuickPresetApiResponse = /** status 201 */ UuidResponseBody;
export type CreateQuickPresetApiArg = {
  body: CreateQuickPresetRequestBody;
};

export type EditQuickPresetApiResponse = /** status 204 */ void;
export type EditQuickPresetApiArg = {
  id: string;
  body: EditQuickPresetRequestBody;
};

export type DeleteQuickPresetApiResponse = /** status 204 */ void;
export type DeleteQuickPresetApiArg = {
  id: string;
};

export type MoveUpQuickPresetApiResponse = /** status 204 */ void;
export type MoveUpQuickPresetApiArg = {
  id: string;
};

export type MoveDownQuickPresetApiResponse = /** status 204 */ void;
export type MoveDownQuickPresetApiArg = {
  id: string;
};
